// extracted by mini-css-extract-plugin
export default {"mobile":"834px","tablet":"835px","desktop":"1440px","logo":"Dashboard_logo__qxgNr","spinner":"Dashboard_spinner__7P8tG"};